import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../services/Toast.service";
import {SwitchBoard} from "../services/SwitchBoard";
import {LoadingService} from "../services/LoadingService";
import {TOAST_TYPE} from "../constants/Tpiq.constants";
import {Session} from "../services/Session";
import {TpiqSelectDropdownComponent} from "../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {TpiqInputSearchComponent} from "../input-search/tpiq-input-search/tpiq-input-search.component";
import {CheckListsService} from "../services/checkLists.service";
import {v4 as uuid} from 'uuid';
import {LinkyModule} from "ngx-linky";

declare const _: any;

@Component({
  selector: 'app-check-list',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, TpiqInputSearchComponent,LinkyModule],
  templateUrl: './check-list.component.html',
  styleUrl: './check-list.component.scss'
})
export class CheckListComponent implements OnInit, OnDestroy {
  tabDisplay: Array<any> = [];
  org: any;
  trackerData: any;
  trackerStatus: string;
  statusId: string;
  checklistId: string;
  checklistLength: any;
  companyId = '';
  singleChecklistData: any;
  disableSave = true;
  clearChecklistInput = true;
  preferredStatuses: any;
  @Input() singlePageviewChecklist: boolean;
  @Input () isTaxPlanningTask: boolean;
  @Input () trackerName: any;
  @Input () taskId: any;
  @Input()
  set data(data){
    if (data && !_.isEmpty(data)) {
      this.checklists = data;
      this.setUpChecklistsData();
    }
  }

  @Output() triggerNavigateToCreateTodo: EventEmitter<any> = new EventEmitter<any>();

  checklists: Array<any> = [];
  statusChecklists: Array<any> = [];
  statusSections: Array<any> = [];
  reveal: any = {
    addChecklist: false,
  };
  selectedChecklists: Array<any> = [];
  allWorkflowsStatusData: any;
  selectedStatusId = '';
  selectedStatusName = '';
  user: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  currentSection = '';
  taxPlanChecklists: Array<any> = [];
  hasSections: boolean = true;
  selectedSectionId: string;
  selectedSectionName: string;
  constructor(private toastService: ToastService, private loadingService: LoadingService,
              private _switchBoard: SwitchBoard, private checkListService: CheckListsService,
              private changeDetectionRef: ChangeDetectorRef) {

    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
  }

  setUpChecklistsData() {
    const base = this;
    if (base.checklists && base.checklists.length > 0) {
      if (base.checklists[0].hasSections) {
        this.hasSections = true;
        this.preferredStatuses = base.checklists[0].sections;
        this.taxPlanChecklists = base.checklists[0].sections || [];
        this.setTabDisplayForTaxPlanTask(base.checklists);
        this.setSwitchTabForTaxPlanTask(base.checklists);
      } else {
        this.hasSections = false;
        this.taxPlanChecklists = base.checklists;
        this.setTabDisplay(base.checklists);
        this.setSwitchTab(base.checklists);
      }
    }

  }

  setTabDisplay(response){
    const base = this;
    if (response.length > 0){
      _.forEach(response, function(type) {
        const obj = {
          display: 'none',
        };
        base.tabDisplay.push(obj);
      });
    }
  }
  setTabDisplayForTaxPlanTask(response){
    const base = this;
    if (response.length > 0){
      _.forEach(response[0].sections, function(type) {
        const obj = {
          display: 'none',
        };
        base.tabDisplay.push(obj);
      });
    }
  }

  setSwitchTab(response){
    if (response.length > 0){
      const index = _.findIndex(response, {id: this.trackerStatus});
      if (index == -1){
        this.switchTab(response[0], 0);
        this.selectedStatusId = response[0].id;
        this.selectedStatusName = response[0].statusName;
      }else{
        this.switchTab(response[index], index);
        this.selectedStatusId = response[index].id;
        this.selectedStatusName = response[index].statusName;
      }
    } else {
      const status = _.find(this.preferredStatuses, {statusId: this.trackerStatus});
      if (status) {
        this.selectedStatusId = status.statusId;
        this.selectedStatusName = status.status;
      }
    }
  }
  setSwitchTabForTaxPlanTask(response){
    if (response.length > 0) {
      const sectionData = response[0].sections;
      this.taxPlanChecklists = response[0].sections;
      if (sectionData && sectionData.length > 0){
        const index = _.findIndex(sectionData, {id: this.trackerStatus});
        if (index == -1){
          this.switchTabForTaxPLan(sectionData[0], 0);
          this.selectedStatusId = sectionData[0].id;
          this.selectedStatusName = sectionData[0].name;
        }else{
          this.switchTabForTaxPLan(sectionData[index], index);
          this.selectedStatusId = sectionData[index].id;
          this.selectedStatusName = sectionData[index].name;
        }
      } else {
        const status = _.find(this.preferredStatuses, {statusId: this.trackerStatus});
        if (status) {
          this.selectedStatusId = status.statusId;
          this.selectedStatusName = status.status;
        }
      }
    }
  }

  switchTab(data, tabNum) {
    const base = this;
    this.tabDisplay.forEach(function(tab, index){
      base.tabDisplay[index] = {display: 'none'};
    });
    this.tabDisplay[tabNum] = {display: 'block'};
    this.statusChecklists = data.checklist;
    base.trackerStatus = data.id;
    base.selectedStatusId = data.id;
    base.selectedStatusName = data.statusName;
    base.statusId = data.id;
    base.checklistId = data.defaultchecklist_id;
    base.checklistLength = data.checklist.length;
  }

  switchTabForTaxPLan(data, tabNum) {
    const base = this;
    this.tabDisplay.forEach(function(tab, index){
      base.tabDisplay[index] = {display: 'none'};
    });
    this.tabDisplay[tabNum] = {display: 'block'};
    this.statusSections = data.checklists || [];
    base.trackerStatus = data.id;
    base.selectedStatusId = data.id;
    base.selectedStatusName = data.name;
    base.statusId = data.id;
    base.checklistId = data.defaultchecklist_id || '';
    base.checklistLength = data.checklists.length;
  }

  closeModalDailog(){
    this.trackerStatus = '';
    this.tabDisplay[0] = {display: 'none'};
    this._switchBoard.onRevealClose.next('checklist');
  }

  saveCheckList(){
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.checkListService.addChecklists(base.org, base.taskId, base.checklists)
      .subscribe(success  => {
        base.checklists = success.checklist;
        this.setTabDisplayForTaxPlanTask(success.checklist);
        this.setSwitchTabForTaxPlanTask(success.checklist);
        if (success.refreshPage && this.singlePageviewChecklist) {
          this._switchBoard.onRefreshTrackerPage.next({});
        } else if (success.refreshPage) {
          this._switchBoard.onRefreshTrackerPage.next({});
        }
        this.toastService.pop(TOAST_TYPE.success,  'Check List Updated Successfully');
        this.loadingService.triggerLoadingEvent(false);
      }, error =>  {
        this.loadingService.triggerLoadingEvent(false);
        const message = error && error.message ? error.message : 'Failed To Update Check List';
        this.toastService.pop(TOAST_TYPE.error, message);
      });
  }

  ngOnInit(){}

  ngOnDestroy(){
  }

  deleteChecklistItems($event, index, check) {
    const base = this;
    const checklist = check[index];
    const selectedChecklist = [
      {
        id: base.statusId,
        statusName: base.selectedStatusName,
        entityId: '',
        defaultchecklist_id: base.checklistId,
        checklist: [checklist],
      }
    ];
    this.loadingService.triggerLoadingEvent(true);
    this.checkListService.deleteChecklist(base.user, base.taskId, checklist.id, selectedChecklist, true)
      .subscribe(success => {
        check.splice(index, 1);
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Checklist Deleted Successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Delete Checklist');
      });
  }

  checkReferences($event, index, check){
    const base = this;
    const checklist = check[index];
    checklist.done = !checklist.done;
    checklist.updated = true;
    checklist.applicable = true;
    const selectedChecklist = [
      {
        id: base.statusId,
        statusName: base.selectedStatusName,
        entityId: '',
        defaultchecklist_id: base.checklistId,
        checklist: [checklist],
      }
    ];
  }

  updateChecklist(checkListId, checklist) {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.checkListService.deleteChecklist(base.user, base.taskId, checkListId, checklist, false)
      .subscribe(success => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Checklist Updated Successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Checklist');
      });
  }

  checkApplicable($event, index, check){
    const base = this;
    const checklist = check[index];
    checklist.applicable = !checklist.applicable;
    checklist.updated = true;
    checklist.done = false;
    const selectedChecklist = [
      {
        id: base.statusId,
        statusName: base.selectedStatusName,
        entityId: '',
        defaultchecklist_id: base.checklistId,
        checklist: [checklist],
      }
    ];
  }

  checkBanks(list, index){
    list.updated = true;
  }

  openCheckList() {
    this.selectedSectionId = this.selectedStatusId;
    this.selectedSectionName = this.selectedStatusName;
    this.reveal = {...this.reveal, addChecklist: true};
  }

  hideReveal(revealFlag){
    this.reveal[revealFlag] = false;
    if (!(this.changeDetectionRef as ViewRef).destroyed) {
      this.changeDetectionRef.detectChanges();
    }
  }

  closeDailog(flag) {
    this.selectedChecklists = [];
    this.hideReveal(flag);
  }

  onCheckListStatusSelect(event) {
    if (!_.isEmpty(event)) {
      this.selectedSectionId = event.id
      this.selectedSectionName = event.name;
    } else {
      this.selectedSectionId = '';
      this.selectedSectionName = '';
    }
  }

  onAddChecklist($event){
    const obj: any = {
      statusId: '',
      sectionId: this.selectedSectionId,
      sectionName: this.selectedSectionName,
      taskId: this.taskId,
      id: uuid(),
      order: 0,
      org: this.org,
      entityType: 'Task',
      name: $event.newEntry,
      mandatory: true,
      description: $event.description,
    };
    if (this.checklists && this.checklists.length > 0) {
      obj.checklistId = this.checklists[0].defaultchecklist_id || '';
      obj.statusId = this.checklists[0].id || '';
    }
    this.selectedChecklists.push(obj);
  }

  removeCheckListValue(index){
    this.selectedChecklists.splice(index, 1);
  }

  onNewChecklistSubmit(){
    const base = this;
    if (base.selectedChecklists.length === 0) {
      this.toastService.pop(TOAST_TYPE.warning, 'Add Checklist');
    } else {
      this.loadingService.triggerLoadingEvent(true);
      this.checkListService.addNewChecklists(this.org, this.selectedChecklists)
        .subscribe(success  => {
          if (success && success.length > 0) {
            this.pushChecklist(success);
            this.toastService.pop(TOAST_TYPE.success, `Added New checklist to ${base.selectedSectionName}`);
            this.loadingService.triggerLoadingEvent(false);
          }
        }, error =>  {
          this.loadingService.triggerLoadingEvent(false);
          const message = error && error.message ? error.message : 'Failed To Add Check List';
          this.toastService.pop(TOAST_TYPE.error, message);
        });
    }
  }

  pushChecklist(success){
    const base = this;
    const checkobj = {
      checklists : [],
      id: '',
      name: '',
    };
    _.forEach(success, function(checklist) {
      const obj = {
        id: checklist.id,
        info: '',
        applicable: true,
        done: false,
        mandatory: checklist.mandatory,
        updated: false,
        name: checklist.name,
        taskCheckListId: '',
        strategyChecklistId: '',
        sectionId: checklist.sectionId || '',
        description: checklist.description
      };
      const list = _.find(base.taxPlanChecklists, {id: checklist.sectionId});
      if (list){
        list.checklists.push(obj);
      } else {
        checkobj.id = checklist.sectionId;
        checkobj.name = checklist.sectionName;
        checkobj.checklists = [...checkobj.checklists, obj];
      }
    });
    if (checkobj.checklists && checkobj.checklists.length > 0) {
      base.taxPlanChecklists = [...base.taxPlanChecklists, checkobj];
      base.trackerStatus = checkobj.id || '';
      base.setTabDisplayForTaxPlanTask(base.taxPlanChecklists );
      base.setSwitchTabForTaxPlanTask(base.taxPlanChecklists );
    }
    this.selectedChecklists = [];
    this.hideReveal('addChecklist');
  }

  openTodoPage(checklist) {
    this.triggerNavigateToCreateTodo.emit(checklist);
  }

}
